(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["early-part-three"] && !Shopify.designMode) return;
  try {
    
    (function () {
        const btnsCopy = document.querySelectorAll('[data-copycode]');
        if (btnsCopy.length && btnsCopy.forEach) {
            btnsCopy.forEach((item) => {
                item.addEventListener('click', () => {
                    const copycode = item.getAttribute('data-copycode');
                    try {
                        navigator.clipboard.writeText(copycode).then((res) => {
                            alert('Copy Successfully!');
                        });
                    } catch (error) {
                        alert('Copy Failed!');
                    }
                });
            });
        }
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["early-part-two"] && !Shopify.designMode) return;
  try {
    
    (function () {
        const btnsCopy = document.querySelectorAll('[data-copycode]');
        if (btnsCopy.length && btnsCopy.forEach) {
            btnsCopy.forEach((item) => {
                item.addEventListener('click', () => {
                    const copycode = item.getAttribute('data-copycode');
                    try {
                        navigator.clipboard.writeText(copycode).then((res) => {
                            alert('Copy Successfully!');
                        });
                    } catch (error) {
                        alert('Copy Failed!');
                    }
                });
            });
        }
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["special-bundle-goods"] && !Shopify.designMode) return;
  try {
    
    class AddToCartMulti extends HTMLElement {
        constructor() {
            super();

            this.miniCart = document.querySelector('mini-cart');
            this.addEventListener('click', this.onClickHandler.bind(this));
        }

        onClickHandler() {
            if (!this.dataset.bundleId) {
                console.error('data-bundle-id does not exist');
                return;
            }
            const variantIds = this.dataset.bundleId.split(',');
            const variantQtys = this.dataset.bundleQty?.split(',') || [];
            const target = this.dataset.target;

            if (variantIds.length) {
                var params = [];
                for (var i = 0; i < variantIds.length; i++) {
                    params.push({
                        id: variantIds[i],
                        quantity: variantQtys[i] || 1,
                    });
                }

                const items = {
                    items: params,
                };

                if (document.body.classList.contains('template-cart') || !theme.shopSettings.cartDrawer) {
                    Shopify.postLink2(theme.routes.cart_add_url, {
                        parameters: {
                            ...items,
                        },
                    });
                    return;
                }

                this.setAttribute('disabled', true);
                this.classList.add('loading');
                const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];

                const body = JSON.stringify({
                    ...items,
                    sections: sections,
                    sections_url: window.location.pathname,
                });

                fetch(`${theme.routes.cart_add_url}`, {...fetchConfig('javascript'), body})
                    .then((response) => response.json())
                    .then((parsedState) => {
                        if (parsedState.status === 422) {
                            document.dispatchEvent(
                                new CustomEvent('ajaxProduct:error', {
                                    detail: {
                                        errorMessage: parsedState.description,
                                    },
                                })
                            );
                        } else {
                            if (target === 'checkout') {
                                window.location.href = '/checkout';
                                return;
                            }

                            this.miniCart && this.miniCart.renderContents(parsedState);

                            document.dispatchEvent(
                                new CustomEvent('ajaxProduct:added', {
                                    detail: {
                                        product: parsedState,
                                    },
                                })
                            );
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        this.classList.remove('loading');
                        this.removeAttribute('disabled');
                    });
            }
        }
    }
    customElements.define('add-to-cart-multi', AddToCartMulti);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test_zcl"] && !Shopify.designMode) return;
  try {
    
    (function () {
        const btnsCopy = document.querySelectorAll('[data-copycode]');
        if (btnsCopy.length && btnsCopy.forEach) {
            btnsCopy.forEach((item) => {
                item.addEventListener('click', () => {
                    const copycode = item.getAttribute('data-copycode');
                    try {
                        navigator.clipboard.writeText(copycode).then((res) => {
                            alert('Copy Successfully!');
                        });
                    } catch (error) {
                        alert('Copy Failed!');
                    }
                });
            });
        }
    })();

  } catch(e) { console.error(e); }
})();
})();
